import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { NgxSpinnerService } from 'ngx-spinner';
import { ComissaoItem } from 'src/app/models/comissao';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import swal from 'sweetalert2';

// jquery
declare const $: any;

@Component({
  selector: 'app-cadastrar-item-comissao',
  templateUrl: './cadastrar-item-comissao.component.html',
  styleUrls: ['./cadastrar-item-comissao.component.scss']
})
export class CadastrarItemComissaoComponent implements OnInit {

  item: ComissaoItem;
  valorTotal = 0;
  tipoTexto = undefined;
  itens: ComissaoItem[] = [];
  public config: PerfectScrollbarConfigInterface = {};

  // construtor
  constructor(public dialogRef: MatDialogRef<CadastrarItemComissaoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private notificacaoService: NotificacaoService,
    private spinner: NgxSpinnerService, private utilitarioService: UtilitarioService) { }

  ngOnInit() {
    this.item = this.data.item;
    this.itens = this.data.itens;

    // this.valorTotal = this.data.valorTotal;
    // this.item.valor = this.utilitarioService.formataNumero(this.item.valor);
  }

  salvar() {

    if (Number(this.item.inicio) > Number(this.item.fim)) {
      swal({
        title: 'O desconto inicial deve ser menor do que o desconto final!',
        text: '',
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-warning',
        type: 'warning'
      }).catch(swal.noop);
    } else if (this.itens.some(p => p.situacao !== 2 && (
      (Number(this.item.inicio) <= Number(p.inicio) && Number(this.item.fim) >= Number(p.inicio) && Number(this.item.fim) <= Number(p.fim)) ||
      (Number(this.item.inicio) <= Number(p.inicio) && Number(this.item.fim) >= Number(p.fim)) ||
      (Number(this.item.inicio) >= Number(p.inicio) && Number(this.item.inicio) <= Number(p.fim) && Number(this.item.fim) <= Number(p.fim)) ||
      (Number(this.item.inicio) >= Number(p.inicio) && Number(this.item.inicio) <= Number(p.fim) && Number(this.item.fim) >= Number(p.fim))))) {
      swal({
        title: 'Já existem percentuais dentro da mesma faixa de desconto!',
        text: 'Deseja substituí-los?',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-info',
        cancelButtonClass: 'btn btn-danger',
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        buttonsStyling: false,
        type: 'warning'
      }).then((result) => {
        if (result.value) {
          this.itens.filter(p => p.situacao !== 2 && (
            (Number(this.item.inicio) <= Number(p.inicio) && Number(this.item.fim) >= Number(p.inicio) && Number(this.item.fim) <= Number(p.fim)) ||
            (Number(this.item.inicio) <= Number(p.inicio) && Number(this.item.fim) >= Number(p.fim)) ||
            (Number(this.item.inicio) >= Number(p.inicio) && Number(this.item.inicio) <= Number(p.fim) && Number(this.item.fim) <= Number(p.fim)) ||
            (Number(this.item.inicio) >= Number(p.inicio) && Number(this.item.inicio) <= Number(p.fim) && Number(this.item.fim) >= Number(p.fim)))).forEach(p => { p.situacao = 2; });

          this.dialogRef.close(this.item);
        }
      });
    } else {
      this.dialogRef.close(this.item);
    }
  }

  fechar() {
    this.dialogRef.close();
  }
}
